import React, { useState, useRef, useEffect } from "react";

const SubCategorySelect = ({ onSubCategoryChange, selectedSubCategory, isMobile }) => {
  const [subCategory, setSubCategory] = useState(selectedSubCategory || "Both");
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);
  const [initial, setInitial] = useState(true);

  const handleSubCategoryChange = (value) => {
    setSubCategory(value);
    setIsOpen(false);
    onSubCategoryChange && onSubCategoryChange(value);
  };

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const list = [
      {
        id: "PE",
        subCategory: "PE",
    },
    {
        id: "M&A",
        subCategory: "M&A",
    },
    {
        id: "Both",
        subCategory: "Both",
    }
  ];

  return (
    <div className="inline-flex items-center mt-[1.25rem] mr-2">
      <div 
        ref={dropdownRef} 
        className="transition-all duration-200 relative"
        style={{ 
          minWidth: isMobile ? "120px" : "180px"
        }}
      >
        {/* Floating label */}
        {!initial && (
          <span className="absolute -top-2 left-3 px-1 bg-white text-xs text-gray-600 z-20">
            Transaction Type
          </span>
        )}

        {/* Trigger paragraph */}
        <p
          className={`cursor-pointer px-3 py-1 border border-gray-300 hover:border-[#b5844c] text-sm font-semibold bg-white hover:bg-gray-50 flex justify-between items-center h-[34px] ${isOpen ? "rounded-t-md border-[#b5844c]" : "rounded-md"}`}
          onClick={() => {setIsOpen(!isOpen); setInitial(false)}}
        >
          <span>{`${selectedSubCategory === "Both" && initial ? "Transaction Type" : selectedSubCategory}`}</span>
          <svg 
            className={`w-4 h-4 transition-transform ${isOpen ? 'rotate-180' : ''}`} 
            fill="none" 
            stroke="currentColor" 
            viewBox="0 0 24 24"
          >
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" color="#CBCBCB"/>
          </svg>
        </p>

        {/* Dropdown menu */}
        {isOpen && (
          <div className="absolute top-full left-0 w-full bg-white border border-[#b5844c] rounded-b shadow-lg z-10">
            {list.map((option) => (
              <div
                key={option.id}
                className={`px-3 py-2 cursor-pointer hover:bg-gray-100 text-sm ${
                  subCategory === option.subCategory ? 'bg-[#f5f5f5] font-semibold' : ''
                }`}
                onClick={() => handleSubCategoryChange(option.subCategory)}
              >
                {option.subCategory}
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default SubCategorySelect;